import first from 'lodash/first';
import ListBookingPaymentSourcesManager from '../../services/ListBookingPaymentSourcesManager';
import type { ListBookingPaymentSourcesResponse } from '../../types/api/v2/obt/model/list-booking-payment-sources-response';
import type { BookingPaymentDetails } from '../../types/api/v1/obt/pnr/payment';
import { getV1PaymentItemsFromV2 } from './getV1PaymentItemsFromV2';

interface IGetBookingPaymentDetails {
  /**
   * Payment Source Ids for each item
   */
  paymentSourceIds: string[];
  numSelectedPoints?: number;
  listBookingPaymentSourcesResponse: ListBookingPaymentSourcesResponse;
}

export const getBookingPaymentDetails = ({
  paymentSourceIds,
  numSelectedPoints,
  listBookingPaymentSourcesResponse,
}: IGetBookingPaymentDetails): BookingPaymentDetails | null => {
  const listBookingPaymentSourcesResponseManager = new ListBookingPaymentSourcesManager(
    listBookingPaymentSourcesResponse,
  );

  const paymentItemsV2 = first(
    first(listBookingPaymentSourcesResponse.allowedPaymentDetails)?.allowedFopRules,
  )?.paymentItems;

  if (!paymentItemsV2 || !paymentSourceIds.length) {
    return null;
  }

  const paymentItems = getV1PaymentItemsFromV2(paymentItemsV2);

  const selectedPayments = listBookingPaymentSourcesResponseManager.getSelectedPayments({
    numSelectedPoints,
    paymentSourceIds,
  });

  if (selectedPayments.length === 0) {
    return null;
  }

  const bookingPaymentDetails: BookingPaymentDetails = {
    bookingTravelerPaymentDetails: [{ selectedFops: [{ paymentItems, selectedPayments }] }],
  };
  return bookingPaymentDetails;
};
